import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Repairs() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/repairs").then((r) => setRows(r.data)); }, []);

  return (
    <div className="p-8 space-y-6" data-testid="repairs-page">
      <header>
        <div className="overline">// voice notes · structured</div>
        <h1 className="font-display font-black text-3xl mt-1">Repair History</h1>
        <p className="text-zinc-500 text-sm mt-1">Voice-note repair records auto-extracted by AI ({rows.length} entries).</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {rows.map((r) => (
          <div key={r.id} className="gs-card p-4" data-testid={`repair-card-${r.id}`}>
            <div className="flex justify-between items-start gap-2">
              <div>
                <div className="text-sm text-zinc-100 font-medium">{r.vehicle || "Vehicle"}</div>
                <div className="text-xs text-zinc-500 font-mono-data">{r.job_type}</div>
              </div>
              <span className="text-[10px] font-mono-data text-zinc-600 uppercase border border-zinc-800 px-1.5 py-0.5">{r.source}</span>
            </div>

            <div className="mt-3 grid grid-cols-2 gap-2 text-xs">
              <div>
                <div className="overline">Mechanic</div>
                <Link to={`/mechanics/${r.mechanic_id}`} className="text-zinc-300 hover:text-amber-500">{r.mechanic_name}</Link>
              </div>
              <div>
                <div className="overline">Parts</div>
                <div className="text-zinc-400">{(r.parts || []).join(", ") || "—"}</div>
              </div>
            </div>

            {r.raw_transcript && (
              <div className="mt-3 border-l-2 border-amber-500/40 pl-2 text-[11px] text-zinc-500 italic">
                "{r.raw_transcript}"
              </div>
            )}

            {/* Waveform mock */}
            <div className="mt-3 flex items-end gap-[2px] h-6">
              {[3, 6, 4, 9, 7, 12, 8, 14, 6, 10, 5, 8, 11, 7, 9, 4, 6, 10, 8, 5].map((h, i) => (
                <div key={i} className="w-[3px] bg-amber-500/40" style={{ height: `${h * 2}px` }} />
              ))}
            </div>
          </div>
        ))}
        {rows.length === 0 && <div className="text-zinc-600 text-sm">No repairs yet.</div>}
      </div>
    </div>
  );
}
